module.exports = __webpack_public_path__ + "static/img/s69.76a641d5.png";